import { render, staticRenderFns } from "./ClientInfoForm.vue?vue&type=template&id=35b74004"
import script from "./ClientInfoForm.vue?vue&type=script&lang=js"
export * from "./ClientInfoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports